import { useState } from "react";
import "./Sidebar.css";
import { NavLink } from "react-router-dom";

import {
    FaHome,
    FaAmbulance,
    FaPlane,
    FaPlaneDeparture,
    FaBars,
    FaBullhorn,
    FaRobot,
    FaMapMarkedAlt,
    FaCogs,
    FaUserShield,
    FaUsers,
    FaKey,
    FaEnvelope,
    FaCog,
    FaChevronDown,
    FaChevronRight,
    FaTh,
    FaConciergeBell,
    FaTools,
    FaTags,
    FaUserCircle,
    FaPalette
} from "react-icons/fa";
import logo from "../assets/kinetiq.png";
import { ROLE_SUPERADMIN, ROLE_ADMIN } from "../utils/auth";

const SECTIONS = [

    {
        key: "dashboard",
        standalone: true,
        to: "/dashboard",
        icon: FaHome,
        label: "Dashboard",
        menuKey: "dashboard"
    },

   /*  {
        key: "manage-profile",
        standalone: true,
        to: "/manage-profile",
        icon: FaUserCircle,
        label: "My Profile",
        alwaysVisible: true
    }, */

    {
        key: "robots",
        label: "Robots",
        icon: FaTh,
        items: [
            { to: "/robot-fleet", icon: FaRobot, label: "Robot Fleet", menuKey: "robot_fleet" },
            { to: "/face-detections", icon: FaUserCircle, label: "Face Detections", menuKey: "robot_fleet" },
            { to: "/manage-robots", icon: FaCogs, label: "Manage Robot", menuKey: "manage_robot" },
            { to: "/poi-locations", icon: FaMapMarkedAlt, label: "POI Location", menuKey: "poi_locations" },
            { to: "/category-master", icon: FaTags, label: "Category Master", menuKey: "poi_locations" },
            { to: "/map-locations", icon: FaMapMarkedAlt, label: "Map Locations", menuKey: "map_locations" },
        ]
    },

    {
        key: "services",
        label: "Services",
        icon: FaConciergeBell,
        items: [
            { to: "/emergencycontacts", icon: FaAmbulance, label: "Emergency Contact", menuKey: "emergency_contacts" },
            { to: "/airport-services", icon: FaPlane, label: "Airport Services", menuKey: "airport_services" },
            { to: "/airport-announcement", icon: FaBullhorn, label: "Airport Announcement", menuKey: "announcements" },
            { to: "/departure-flights", icon: FaPlaneDeparture, label: "Departure Flights", menuKey: "departure_flights" },
        ]
    },

    {
        key: "setup",
        label: "Setup",
        icon: FaTools,
        items: [
            { to: "/manage-users", icon: FaUsers, label: "Manage User", menuKey: "manage_users" },
            { to: "/manage-admins", icon: FaUserShield, label: "Manage Admin", fixedRoles: [ROLE_SUPERADMIN] },
            { to: "/role-permissions", icon: FaKey, label: "Role Permission", fixedRoles: [ROLE_SUPERADMIN] },
            { to: "/user-permissions", icon: FaKey, label: "User Permission", fixedRoles: [ROLE_SUPERADMIN, ROLE_ADMIN] },
            { to: "/send-email", icon: FaEnvelope, label: "Send Email", menuKey: "send_email" },
            { to: "/email-configuration", icon: FaCog, label: "Email Configuration", fixedRoles: [ROLE_SUPERADMIN] },
        
            {key: "theme-settings", standalone: true, to: "/theme-settings", icon: FaPalette, label: "Theme Settings", alwaysVisible: true   },

        ]
    },

];

function Sidebar({ open, setOpen, user, permissions }) {

    const role = user?.role;

    const isSuperAdmin = role === ROLE_SUPERADMIN;

    const canView = (menuKey) => isSuperAdmin || !!permissions?.[menuKey]?.view;

    // Two kinds of item: matrix-driven (menuKey, checked via
    // permissions) or fixedRoles (a hardcoded allow-list, for the
    // handful of pages that are business rules rather than
    // matrix-configurable - see menu_registry.py for why).
    const canSeeItem = (item) => item.fixedRoles ? item.fixedRoles.includes(role) : canView(item.menuKey);

    // Accordion behavior: at most one section open at a time. null =
    // everything collapsed, which is the default right after login -
    // opening Robots auto-closes Services/Setup if either was open,
    // and clicking the currently-open section's header closes it too.
    const [expandedSection, setExpandedSection] = useState(null);

    const toggleSection = (key) => {

        setExpandedSection(prev => (prev === key ? null : key));

    };

    return (

        <div className={`sidebar ${open ? "open" : ""}`}>

            <div className="sidebar-logo">

                <FaBars
                    className="menu-icon"
                    onClick={() => setOpen(!open)}
                />

                <img
                    src={logo}
                    alt="CIAL"
                    className="sidebar-logo-img"
                />

            </div>

            <div className="sidebar-menu">

                {

                    SECTIONS.map(section => {

                        if (section.standalone) {

                            if (!section.alwaysVisible && !canView(section.menuKey)) {
                                return null;
                            }

                            return (

                                <NavLink key={section.key} to={section.to} className="menu-item">
                                    <section.icon />
                                    <span>{section.label}</span>
                                </NavLink>

                            );

                        }

                        const visibleItems = section.items.filter(canSeeItem);

                        if (visibleItems.length === 0) {
                            return null;
                        }

                        const isCollapsed = expandedSection !== section.key;

                        return (

                            <div className="sidebar-section" key={section.key}>

                                <button
                                    type="button"
                                    className="sidebar-section-header"
                                    onClick={() => toggleSection(section.key)}
                                >
                                    <section.icon className="section-icon" />
                                    <span>{section.label}</span>
                                    {isCollapsed ? <FaChevronRight className="chevron" /> : <FaChevronDown className="chevron" />}
                                </button>

                                {

                                    !isCollapsed &&

                                    <div className="sidebar-section-items">

                                        {visibleItems.map(item => (

                                            <NavLink key={item.to} to={item.to} className="menu-item sub-item">
                                                <item.icon />
                                                <span>{item.label}</span>
                                            </NavLink>

                                        ))}

                                    </div>

                                }

                            </div>

                        );

                    })

                }

            </div>

        </div>

    );

}

export default Sidebar;
